import AdDetails from "./AdDetails";
import Confirm from "./Confirm";

// Map of chapterdef KEY: Component
export default {
  AD_DETAILS: AdDetails,
  CONFIRM: Confirm,
};
